import { FC } from 'react';
import { UseRadioGroupProps } from '@chakra-ui/react';

import * as Form from 'components/_core/form';
import locales from 'features/Onboarding/modules/Compliance/pages/ComplianceForm/locales';

enum StringifiedBoolean {
  True = 'true',
  False = 'false',
}

/**
 * Cast a possible boolean option value to a string representation.
 * Chakra doesn't support boolean values.
 */
const toRadioGroupValue = (
  value: boolean | null,
): UseRadioGroupProps['value'] => {
  if (typeof value === 'boolean') {
    return value ? StringifiedBoolean.True : StringifiedBoolean.False;
  }

  return undefined;
};

/**
 * Cast back the string representation to its original type.
 * Reverse operation of the fromValue() function.
 */
const toBoolean = (str: StringifiedBoolean): boolean => {
  return str === StringifiedBoolean.True ? true : false;
};

interface BooleanGroupProps {
  onChange: (value: boolean) => void;
  value: boolean | null;
}

/**
 * A YES/NO radio group handling boolean/null to string/undefined conversion.
 * Since Chakra’s RadioGroup doesn’t accept boolean values.
 */
const BooleanRadioGroup: FC<BooleanGroupProps> = ({ onChange, value }) => {
  const handleChange = (e: StringifiedBoolean) => {
    onChange(toBoolean(e));
  };

  return (
    <Form.Radio.Group
      direction="row"
      onChange={handleChange}
      radioPosition="right"
      spacing="space-8"
      value={toRadioGroupValue(value)}
      variant="outline"
    >
      <Form.Radio minWidth="112px" value={StringifiedBoolean.True}>
        <Form.Radio.Title>{locales.buttonLabelYes}</Form.Radio.Title>
      </Form.Radio>

      <Form.Radio minWidth="112px" value={StringifiedBoolean.False}>
        <Form.Radio.Title>{locales.buttonLabelNo}</Form.Radio.Title>
      </Form.Radio>
    </Form.Radio.Group>
  );
};

export default BooleanRadioGroup;
